import React from 'react'

import classes from './EmployeeData.scss'

import EmployeeCard from './EmployeeCard/EmployeeCard'
import Spinner from '../../../../UI/Spinner/Spinner'

const employeeData = ({ records, loading, onEmpSelected, selectedEmps, editDisabled }) => {
  let empCards = records.map(item => (
    <EmployeeCard
      key={item.emp_id}
      empData={item}
      onEmpSelected={() => onEmpSelected(item.emp_id)}
      selected={selectedEmps.includes(item.emp_id)}
      editDisabled={editDisabled}
    />
  ))
  let data = <Spinner />
  if (!loading) {
    data = empCards
  }
  return <div className={classes.EmployeeDataContainer}>{data}</div>
}

export default employeeData
